import { ParserContentData } from '@libs';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const normalizeBanner = (data) => {
  const item = ParserContentData.getItemData(data, {
    groupKey: 'common',
    blockKey: 'banners',
    itemKey: 'header_and_card',
  });
  const { link = '', description = '', cover = '', color = '', backgroundColor = '', name = '' } = item.formData;

  return {
    id: item.id,
    link,
    description,
    cover,
    color: color || Colors.white,
    backgroundColor: backgroundColor || Colors.electric_blue,
    name: name || description,
  };
};
